import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { authAtom } from "../states/auth";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import * as formik from "formik";
import * as yup from "yup";
import { authenticate } from "../services/authService";
import AlertCustom from "../components/AlertCustom/AlertCustom";
import { useAlert } from "../contexts/AlertContext";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [auth, setAuth] = useAtom(authAtom);
  const [logoutMessage, setLogoutMessage] = useState("");
  const { showAlert } = useAlert();

  const { Formik } = formik;

  const schema = yup.object().shape({
    Email: yup.string().email('Enter valid email address').required('Email is required'),
    Password: yup.string().required('Password is required'),
    language: yup.string().required(),
  });

  const PasswordToggle = (e) => {
    e.preventDefault();
    setShowPassword((prevState) => !prevState);
  };

  useEffect(() => {
    const message = sessionStorage.getItem("logoutMessage");

    if (message) {
      setLogoutMessage(message);
      showAlert({
        title: "Authentication Notification",
        message: message ?? "something went wrong",
        variant: "danger",
      });
      sessionStorage.removeItem("logoutMessage"); // Clear after use
    }
  }, []);

  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    setLoading(true);
    setNotification();

    const data = {
      email: values.Email,
      password: values.Password,
      language: "en",
    };
    console.log("data", data);
    try {
      const res = await authenticate(data);
      console.log("Authentication successful:", res);

      // Transform the response to match the auth state structure
      const authData = {
        isAuthenticated: true,
        user: res.user_details || null,
        token: res.user_details.token || null,
      };

      setAuth(authData);
      if (authData.user.roleId == 2) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/inbox", { replace: true });
      }
    } catch (error) {
      console.error("Authentication failed:", error.response.data.message);
      setNotification(
        <AlertCustom
          message={error?.response?.data?.message ?? "something went wrong"}
          variant="danger"
        />
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="text-center">
        <h1 className="fs-1 fw-bold text-gray-700 mb-2">Welcome back!</h1>
        <h2 className="fs-5 fw-normal text-gray-500">
          Hello there, Please enter details below to login
        </h2>
      </div>
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          email: "",
          password: "",
          language: "en",
        }}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form className="mt-5" onSubmit={handleSubmit}>
            {notification}
            <Form.Group className="mb-4" controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              
              <div className="input-warpper email-icon">
                <Form.Control
                  type="text"
                  placeholder="Enter your email"
                  aria-describedby="inputGroupPrepend"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  isInvalid={!!errors.Email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Email}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <div className="input-warpper lock-icon">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  name="Password"
                  value={values.Password}
                  onChange={handleChange}
                  isInvalid={!!errors.Password}
                />

                <button
                  type="button"
                  className="input-group-icon btn-reset right"
                  onClick={PasswordToggle}
                >
                  <Image
                    src={
                      !showPassword ? "/images/eye-off.svg" : "/images/eye.svg"
                    }
                    width={20}
                    height={20}
                    alt="Eye Icon"
                  />
                </button>

                <Form.Control.Feedback type="invalid">
                  {errors.Password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group
              className="d-flex align-items-center justify-content-between gap-3"
              controlId="formBasicCheckbox"
            >
              <Form.Check type="checkbox" label="Remember Me" />
              <Link
                to="/auth/forgot-password"
                className="text-gray-700 fw-semibold text-decoration-none"
              >
                Forgot Password?
              </Link>
            </Form.Group>

            <Button type="submit" className="btn btn-primary w-100 mt-5" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : "Sign In"}
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Login;
